import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { offerActions } from 'actions';
import { useRedux } from 'shared/hooks';

/**
 * Fetches an offer package for a given personal loan application UUID.
 * @param {Boolean} shouldFetch Boolean to determine if useOffer should call getOfferPackage.
 * @returns {Object} An object containing the list of offers for the given application and a loading flag.
 */
const useOffer = (shouldFetch = false) => {
  const { uuid: personalLoanUuid } = useParams();
  const { offerPackagesByApplicationUuid, ...rest } = useRedux('offerReducer', offerActions);
  const { getOfferPackage } = rest;

  useEffect(() => {
    if (personalLoanUuid && shouldFetch) getOfferPackage(personalLoanUuid);
  }, [personalLoanUuid]);

  return {
    ...rest,
    offerPackage: offerPackagesByApplicationUuid[personalLoanUuid] || {},
  };
};

export default useOffer;
